// src/components/Logout.jsx
import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function Logout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    async function logAndLogout() {
      try {
        // your login user object has USER_ID, USER_NAME, USER_SURNAME
        if (user?.USER_ID) {
          await fetch(`${API_BASE}/api/audit_log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              user_id:   user.USER_ID,
              user_name: `${user.USER_NAME} ${user.USER_SURNAME}`,
              action:    'logout',
              details:   'User logged out.'
            })
          });
        }
      } catch (err) {
        console.error('Audit log failed:', err);
      } finally {
        logout();
        navigate('/login');
      }
    }
    logAndLogout();
  }, [user, logout, navigate]);

  return null;
}
